import gql from "graphql-tag";

export const BA_AcceptRequest = gql`
  mutation ba_AcceptRequest($input: BA_AcceptRequestInput!) {
    BA_AcceptRequest(input: $input) {
      clientMutationId
    }
  }
`;

export const BA_DeclineRequest = gql`
  mutation ba_DeclineRequest($input: BA_DeclineRequestInput!) {
    BA_DeclineRequest(input: $input) {
      clientMutationId
    }
  }
`;

export const BA_SendRequest = gql`
  mutation ba_SendRequest($input: BA_SendRequestInput!) {
    BA_SendRequest(input: $input) {
      clientMutationId
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/assistant/Broker_Assignment/Mutations.js